import { render, staticRenderFns } from "./GasesLimit.vue?vue&type=template&id=50e46a04&scoped=true&"
import script from "./GasesLimit.vue?vue&type=script&lang=js&"
export * from "./GasesLimit.vue?vue&type=script&lang=js&"
import style0 from "./GasesLimit.vue?vue&type=style&index=0&id=50e46a04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e46a04",
  null
  
)

export default component.exports